import * as types from "../actions/actionTypes";
import { sort } from "../lib/listMethods";
const DEFAULT_COST_CENTER = {
  name: "",
  description: "",
  accounting_codes: []
};
const initialState = {
  loading: false,
  data: [],
  error: "",
  isFetched: false,
  last_item: "",
  cost_center: DEFAULT_COST_CENTER,
  storeProcessing: false,
  storeStatus: false,
  removeProcessing: false,
  showLoading: false,
  showError: ""
};

const CostCenter = (state = initialState, action) => {
  let data;
  switch (action.type) {
    case types.GET_COST_CENTER_REQUEST:
      return { ...state, loading: true, error: "", isFetched: false };
    case types.GET_COST_CENTER_SUCCESS:
      return {
        ...state,
        data: action.payLoad,
        loading: false,
        isFetched: true
      };
    case types.GET_COST_CENTER_FAILURE:
      return { ...state, loading: false, error: action.error };

    case types.SHOW_COST_CENTER_REQUEST:
      return {
        ...state,
        cost_center: DEFAULT_COST_CENTER,
        showLoading: true,
        showError: ""
      };
    case types.SHOW_COST_CENTER_SUCCESS:
      return { ...state, cost_center: action.payLoad, showLoading: false };
    case types.SHOW_COST_CENTER_FAILURE:
      return { ...state, showLoading: false, showError: action.error };

    case types.UPDATE_COST_CENTER_REQUEST:
      return { ...state, storeProcessing: true };
    case types.UPDATE_COST_CENTER_SUCCESS:
      data = [];
      if (state.data.length) {
        data = state.data.map(item => {
          if (item.id === Number(action.payLoad.id)) {
            return { ...action.payLoad };
          } else {
            return item;
          }
        });
      }
      return {
        ...state,
        cost_center: action.payLoad,
        storeProcessing: false,
        data: sort(data, true, "name")
      };
    case types.UPDATE_COST_CENTER_FAILURE:
      return { ...state, storeProcessing: false };

    case types.STORE_COST_CENTER_REQUEST:
      return { ...state, storeProcessing: true };
    case types.STORE_COST_CENTER_SUCCESS:
      data = [...state.data];
      let founded = false;
      if (data.length) {
        data = data.map(item => {
          if (item.id === Number(action.payLoad.id)) {
            founded = true;
            return { ...action.payLoad };
          } else {
            return item;
          }
        });
      }
      if (!founded) {
        data.push(action.payLoad);
      }
      return {
        ...state,
        storeProcessing: false,
        last_item: action.payLoad,
        data: sort(data, true, "name"),
        storeStatus: true
      };
    case types.STORE_COST_CENTER_FAILURE:
      return { ...state, storeProcessing: false, storeStatus: false };

    case types.REMOVE_COST_CENTER_REQUEST:
      return { ...state, removeProcessing: true };
    case types.REMOVE_COST_CENTER_SUCCESS:
      data = [...state.data]; // because deepCopy is needed :)
      data = data.filter(item => item.id !== Number(action.payLoad));
      return { ...state, data: data, removeProcessing: false };
    case types.REMOVE_COST_CENTER_FAILURE:
      return { ...state, removeProcessing: false };
    case types.CLEAR_COST_CENTER_LIST:
      return { ...state, data: [], isFetched: false };
    default:
      return state;
  }
};

export default CostCenter;
